"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.VIEWS, (table)=>{
        table.string('created_by', 20).index();
        table.string('owned_by', 20).index();
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.VIEWS, (table)=>{
        table.dropColumn('created_by');
        table.dropColumn('owned_by');
    });
};
